import { render, staticRenderFns } from "./DiscountInformation.vue?vue&type=template&id=09f0646c&scoped=true"
import script from "./DiscountInformation.vue?vue&type=script&lang=ts"
export * from "./DiscountInformation.vue?vue&type=script&lang=ts"
import style0 from "./DiscountInformation.vue?vue&type=style&index=0&id=09f0646c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f0646c",
  null
  
)

export default component.exports